const indexItems = [
  { title: '热血冒险', icon: 'ri-fire-line', desc: '燃爆全场的战斗与成长之旅', count: '8.2k' },
  { title: '恋爱校园', icon: 'ri-heart-line', desc: '青春悸动的甜蜜恋爱物语', count: '6.5k' },
  { title: '玄幻修仙', icon: 'ri-moon-clear-line', desc: '逆天改命的仙侠修真传奇', count: '9.1k' },
  { title: '悬疑推理', icon: 'ri-search-eye-line', desc: '抽丝剥茧的烧脑推理盛宴', count: '4.8k' },
  { title: '搞笑日常', icon: 'ri-emotion-laugh-line', desc: '轻松解压的爆笑日常故事', count: '7.3k' },
  { title: '科幻未来', icon: 'ri-rocket-line', desc: '想象力爆棚的未来世界探索', count: '3.6k' },
  { title: '古风历史', icon: 'ri-ancient-gate-line', desc: '华丽古韵的历史风云画卷', count: '5.2k' },
  { title: '都市职场', icon: 'ri-building-line', desc: '现实与梦想交织的都市故事', count: '4.1k' },
  { title: '治愈温情', icon: 'ri-empathize-line', desc: '温暖人心的治愈系好故事', count: '5.9k' },
];

export default function IndexSection() {
  const handleClick = () => {
    const el = document.querySelector('#carousel');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热门专题
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-10 md:mb-14 max-w-xl mx-auto">
          按题材分类浏览，快速找到你喜欢的免费漫画类型
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              onClick={handleClick}
              className="bg-background-50 rounded-xl p-5 flex items-center gap-4 hover:bg-background-200/50 transition-colors cursor-pointer group"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm text-foreground-900 mb-0.5">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs truncate">{item.desc}</p>
              </div>
              <span className="text-xs text-foreground-400 shrink-0">{item.count}部</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}